var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showAddToCalendar ? _c('add-to-calendar-dialog', {
    attrs: {
      "event": _vm.order.event
    },
    model: {
      value: _vm.showAddToCalendar,
      callback: function ($$v) {
        _vm.showAddToCalendar = $$v;
      },
      expression: "showAddToCalendar"
    }
  }) : _vm._e(), _vm.showHeaders ? [_c('div', {
    staticClass: "text--label-active mb-4"
  }, [_c('div', [_c('span', {
    staticClass: "overline short grey--text mr-1"
  }, [_vm._v("From")]), _vm.from ? [_vm._v(_vm._s(_vm.from) + " <")] : _vm._e(), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.skin.email_from || 'delivery@ellacard.com')
    }
  }), _vm.from ? [_vm._v(">")] : _vm._e()], 2), !_vm.skin.email_from && _vm.global.profile ? _c('div', [_c('span', {
    staticClass: "overline short grey--text mr-1"
  }, [_vm._v("Reply-to")]), _vm._v(" " + _vm._s(_vm.global.profile.email) + " ")]) : _vm._e(), _c('div', [_c('span', {
    staticClass: "overline short grey--text mr-1"
  }, [_vm._v("Subject")]), _vm._v(" " + _vm._s(_vm.skin.email_subject) + " ")])])] : _vm._e(), _c('div', [_c('div', {
    staticClass: "email-root"
  }, [_c('v-card', {
    style: {
      color: _vm.color,
      'background-color': _vm.skin.page_background_color || '#FFF'
    },
    attrs: {
      "tile": ""
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('p', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "mx-auto email-subject preserve-newlines",
    domProps: {
      "innerHTML": _vm._s(_vm.skin.email_subject)
    }
  })]), _vm.toTxt ? _c('p', [_c('span', {
    staticClass: "email-to-from"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.toTxt)
    }
  })]) : _vm._e(), _vm.fromTxt ? _c('p', [_c('span', {
    staticClass: "email-to-from"
  }, [_vm._v("FROM")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.fromTxt)
    }
  })]) : _vm._e(), _vm.followUpMsg ? [_c('br'), _c('p', {
    staticClass: "preserve-newlines"
  }, [_vm._v(_vm._s(_vm.followUpMsg))])] : _vm._e()], 2), _c('v-card', {
    staticClass: "mx-auto relative overflow-hidden",
    staticStyle: {
      "max-width": "92%",
      "aspect-ratio": "7 / 5"
    },
    attrs: {
      "hover": "",
      "tile": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('preview');
      }
    }
  }, [_c('envelope', {
    staticStyle: {
      "position": "absolute",
      "inset": "-20% 0 -20% 0"
    },
    attrs: {
      "skin": _vm.skin,
      "from": _vm.from,
      "to": _vm.to
    }
  })], 1), _c('div', {
    staticClass: "px-4 py-8"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('preview');
      }
    }
  }, [_vm._v(" Open " + _vm._s(_vm.order.type == 'INVITATION' ? 'invitation & RSVP' : 'card') + " ")])], 1), _vm.order.type == 'INVITATION' && _vm.order.event ? _c('div', {
    staticClass: "pb-8 text-center"
  }, [_vm.order.event.name ? [_c('br'), _c('div', {
    staticClass: "font-weight-bold preserve-newlines"
  }, [_vm._v(_vm._s(_vm.order.event.name))]), !_vm.order.event.lz_date ? _c('br') : _vm._e()] : _vm._e(), _vm.order.event.lz_date ? [_c('br'), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.order.event.lz_date))]), _c('div', [_vm._v(_vm._s(_vm.order.event.lz_time_range) + " " + _vm._s(_vm.order.event.lz_tz_name))]), !_vm.hasLocation ? _c('br') : _vm._e()] : _vm._e(), _vm.hasLocation ? [_c('br'), _vm.order.event.location ? _c('div', {
    staticClass: "font-weight-bold preserve-newlines"
  }, [_vm._v(_vm._s(_vm.order.event.location))]) : _vm._e(), _vm.order.event.address ? _c('div', {
    staticClass: "preserve-newlines"
  }, [_vm._v(_vm._s(_vm.order.event.address))]) : _vm._e(), _c('br')] : _vm._e(), _vm.order.event.lz_date ? _c('div', [_c('br'), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showAddToCalendar = true;
      }
    }
  }, [_vm._v("Add to calendar")])], 1) : _vm._e(), _vm.order.event.url_map ? _c('div', [_c('br'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "target": "_blank",
      "href": _vm.order.event.url_map
    }
  }, [_vm._v("Map link")])], 1) : _vm._e(), _vm.order.event.url_virtual ? _c('div', [_c('br'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "target": "_blank",
      "href": _vm.order.event.url_virtual
    }
  }, [_vm._v("Virtual event link")])], 1) : _vm._e()], 2) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "px-4 py-8 d-flex justify-center align-center"
  }, [_c('div', {
    staticClass: "email-logo relative"
  }, [_vm.skin.email_footer_logo ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.skin.email_footer_url
    }
  }, [_c('img', {
    staticClass: "d-block",
    attrs: {
      "height": "67",
      "src": _vm.skin.email_footer_logo
    }
  })]) : _vm._e()])]), _c('div', {
    staticClass: "email-secondary text-center pb-4 px-4"
  }, [_vm.email ? [_vm._v("This message was sent to: " + _vm._s(_vm.email)), _c('br')] : _vm._e(), _c('a', {
    staticClass: "black--text",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Unsubscribe")])], 2)])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }